exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".whs-breadcrumbs[data-v-0ad98af6]{padding:12px 12px 0;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.whs-breadcrumbs-item[data-v-0ad98af6]{padding:2px 8px 2px 0;color:var(--color-main);font-weight:500;cursor:pointer}.whs-breadcrumbs-item.is-not-clickable[data-v-0ad98af6],.whs-breadcrumbs-item[data-v-0ad98af6]:last-child{color:var(--color-text);font-weight:400;cursor:default}.whs-breadcrumbs-item.whs-icon[data-v-0ad98af6]:before{content:\"\\F054\";color:var(--color-alt-5);margin-right:8px}", ""]);

// exports
